import * as controlsActions from '../actions/controls';

const defaultState = {
  controlsVisible: false,
  menuVisible: false,
  seekingTime: 0,
  seekMode: false,
};

export default function controls(state = defaultState, action = {}) {
  switch (action.type) {
    case controlsActions.SHOW: {
      return {
        ...state,
        controlsVisible: action.show,
      };
    }

    case controlsActions.SHOW_MENU: {
      return {
        ...state,
        menuVisible: action.menuVisible,
      };
    }

    case controlsActions.SET_SEEKING_TIME: {
      return {
        ...state,
        seekingTime: action.seekingTime,
      };
    }

    case controlsActions.SET_SEEK_MODE: {
      return {
        ...state,
        seekMode: action.seekMode,
      };
    }

    default: {
      return state;
    }
  }
}
